export const cutString = string => {
    if(string.length > 35) {
        const type = string.split('.')[string.split('.').length - 1];
        return string.slice(0, 32 - type.length) + '...' + type;
    }

    return string;
};